var getElem = setInterval(function () {
//   document.querySelectorAll('.Engraving').forEach(engraving => {
//     engraving.removeAttribute('style');
//     engraving.querySelectorAll('input[type="text"]').forEach(input => {
//         input.removeAttribute('disabled');
//         input.removeAttribute('required');
//     });
// });

}, 10);

  document.addEventListener("DOMContentLoaded", function () {
    const radioButtons = document.querySelectorAll(".custom-radio--color");
    const dropdown = document.querySelector(".metal-custom--color");
    radioButtons.forEach(function (radio) {
        radio.addEventListener("change", function () {
            if (dropdown) {
                dropdown.value = this.value;
                dropdown.dispatchEvent(new Event("change")); // Trigger change event
            }
        });
    });
 
    // Scroll to target
    let announcementBar = document.querySelector('.announcement-sticky-wrapper');
    let header = document.querySelector('.header');
    
    let announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    let headerHeight = header ? header.offsetHeight : 0;
    let deskTotalHeight = headerHeight + announcementBarHeight;
    
    /* Scroll to target */
    document.querySelectorAll('.scrollTo').forEach(function(element) {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        
        let targetId = element.getAttribute('href');
        let targetElement = document.querySelector(targetId);
    
        if (targetElement) {
          let newPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          let scrollPosition = newPosition - deskTotalHeight;
    
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
    
          // Optional: Perform a second scroll for adjustments
          setTimeout(() => {
            let adjustedPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - deskTotalHeight;
            window.scrollTo({
              top: adjustedPosition,
              behavior: 'smooth'
            });
          }, 800);
        }
      });
    });
    
});

function waitForElement(selector, callback, interval = 100) {
  let checkExist = setInterval(function () {
      let element = document.querySelector(selector);
      if (element) {
          clearInterval(checkExist);
          callback(element);
      }
  }, interval);
}

// Wait for input[name-disabled="properties[Engraving Text]"]
waitForElement('input[name-disabled="properties[Engraving Text]"]', function (input) {
  //document.querySelector('#Engraving-0-1').value = 'No';
  //document.querySelector('[name="properties[Engraving]"]').value = 'No';
  input.addEventListener('keyup', function (event) {
    //let engravingField = document.querySelector('#Engraving-0-1');
    let engravingField = document.querySelector('[name="properties[Engraving]"]');

    
    let productPriceElement = document.querySelector(".variant-selection__variants");
    let engravingProductPrice = document.body.getAttribute("data-engraving-product");
    let selectedOption = productPriceElement.options[productPriceElement.selectedIndex]; // Get selected <option>
    let productPrice = selectedOption.getAttribute("data-price-without-formate");
    let productOrignalPrice = selectedOption.getAttribute("data-price-with-formate");
    let totalPrice = (parseFloat(productPrice) || 0) + (parseFloat(engravingProductPrice) || 0);
    let moneyFormat = document.body.getAttribute("data-money-format");
    let formattedPrice = Shopify.formatMoney(totalPrice, moneyFormat);
    let orignalPrice = Shopify.formatMoney(productPrice, moneyFormat); 
    let priceElementt = document.querySelector(".engraving-product-addition--price");
  // Select the <select> element with name 'properties[Engraving]'

  

    if (engravingField && input.value.trim() !== '') {
        engravingField.value = 'Yes';
        if (priceElementt) {
          priceElementt.textContent = formattedPrice;
       }
       let engravingInput = document.querySelector('input[name-disabled="properties[Engraving Text]"]');

    if (engravingInput) {
        engravingInput.setAttribute('name', 'properties[Engraving Text]');
        engravingInput.removeAttribute('name-disabled');
    }
       
    }else{
      engravingField.value = 'No';
      priceElementt.textContent = orignalPrice;
    }
    //engravingField.dispatchEvent(new Event('change'));
        
    

  });
  const selectElement = document.querySelector('select[name="properties[Engraving]"]');


if (selectElement && selectElement.options.length > 0) {
  // Change the text of the first option
  selectElement.options[0].textContent = "Add Engraving ($45)"; 
}
  let label = document.querySelector('[for="Size-0-0"]');
 

if (label) {
    let link = document.createElement('a');
    link.href = 'javascript:void(0)';
    link.className = 'identify-your-ring-size';
    link.setAttribute('data-fancybox', '');
    link.setAttribute('data-src', '#identifyYourRingSize');
    link.textContent = 'Identify your ring size';
    link.style.marginLeft = '10px'; // Optional spacing

    label.after(link); // Insert the link right after the label
}
// size code here
var sizeSelect = document.getElementById("Size-0-0");
if (!sizeSelect) return; // Ensure the dropdown exists

  if (label.parentNode.classList.contains('spb-label-tooltip')) {
    let parentNode = label.parentNode;
    let selectSizeWrapper = parentNode.querySelector('.select-size-button-wrapper');
    if (!selectSizeWrapper) {
      selectSizeWrapper = document.createElement("div");
      selectSizeWrapper.classList.add('select-size-button-wrapper');
      
      insertAfter(selectSizeWrapper, parentNode);
    }
  
    let existingSelecter = selectSizeWrapper.querySelector('.dropdown-select');
    
    if (selectSizeWrapper && !existingSelecter) {

      let existingSelecterWrap = selectSizeWrapper.querySelector('.cw-product-bundle__variant-select');
      if (!existingSelecterWrap) {
    
        let selecterWrap = document.createElement('div');
        selecterWrap.classList.add('cw-product-bundle__variant-select', 'dropdown-select', 'js-dropdown-select');
        
        let existingSelectedOption = selecterWrap.querySelector('.cw-product-bundle__variant-selected');
        if (!existingSelectedOption) {
          let selectedOption = document.createElement('div');
          selectedOption.classList.add('cw-product-bundle__variant-selected', 'dropdown-selected-option', 'js-selected-option');
    
          let selectedText = document.createElement('span');
          selectedText.classList.add('cw-product-bundle__variant-text', 'dropdown-selected-option-text');
          selectedText.textContent = 'Select Ring Size';
          
          selectedOption.appendChild(selectedText);
          selecterWrap.appendChild(selectedOption);
        }
    
        let existingOptionsWrapper = selecterWrap.querySelector('.cw-product-bundle__variant-options');
        if (!existingOptionsWrapper) {
          let optionsWrapper = document.createElement('div');
          optionsWrapper.classList.add('cw-product-bundle__variant-options', 'dropdown-options');
          selecterWrap.appendChild(optionsWrapper);
        }
    
        let existingHiddenInput = selecterWrap.querySelector('input[type="hidden"]');
        if (!existingHiddenInput) {
          let hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'selectedValue';
          hiddenInput.value = '';
          selecterWrap.appendChild(hiddenInput);
        }
    
        selectSizeWrapper.appendChild(selecterWrap);
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('size-error-message');
        errorMessage.textContent = 'Please select a ring size'; // Customize your message
        errorMessage.style.display = 'none'; // Initially hidden
        selectSizeWrapper.appendChild(errorMessage);
      } else {
        
      }
    }

    if(selectSizeWrapper.querySelector('.cw-product-bundle__variant-options')){
      console.log("existingOptionsWrapper For Option : ", selectSizeWrapper.querySelector('.cw-product-bundle__variant-options'));

      // Create the "Select Ring Size" placeholder option and append it first
      let placeholderOption = document.createElement("div");
      placeholderOption.classList.add('cw-product-bundle__variant-option', 'dropdown-option');
      placeholderOption.setAttribute('data-text', "");

      let placeholderText = document.createElement("span");
      placeholderText.classList.add('cw-product-bundle__option-text');
      placeholderText.textContent = "Select Ring Size"; // Placeholder text

      placeholderOption.appendChild(placeholderText);
      selectSizeWrapper.querySelector('.cw-product-bundle__variant-options').appendChild(placeholderOption);

      // Initially, set the "Select Ring Size" as selected (to display it as the default text)
      placeholderOption.classList.add("selected");
      
      // Loop through each option in the select dropdown
      for (let i = 0; i < sizeSelect.options.length; i++) {
        let option = sizeSelect.options[i];
        console.log("option : ", option);

        let value = option.value.trim();
        console.log("value : ", value);

        let text = option.text.trim();
        console.log("text : ", text);

        if (value) { // Avoid empty options
          let swatchBlock = document.createElement("div");
          swatchBlock.classList.add('cw-product-bundle__variant-option', 'dropdown-option');
          swatchBlock.setAttribute('data-text', value);

          let swatchOptionText = document.createElement("span");
          swatchOptionText.classList.add('cw-product-bundle__option-text');
          swatchOptionText.textContent = text;

          // let swatchMadeToOrder = document.createElement("span");
          // swatchMadeToOrder.textContent = "Made to Order";

          swatchBlock.appendChild(swatchOptionText);
          // swatchBlock.appendChild(swatchMadeToOrder);
          selectSizeWrapper.querySelector('.cw-product-bundle__variant-options').appendChild(swatchBlock);

          // if (sizeSelect.value === value) {
          //   swatchBlock.classList.add("selected");
          // }

          // Click event to update dropdown
          swatchBlock.addEventListener("click", function () {
            document.querySelectorAll(".dropdown-option").forEach(function(el) {
              el.classList.remove("selected");
            });
            this.classList.add("selected");

            sizeSelect.value = this.getAttribute("data-text");
            console.log("sizeSelect.value : ", sizeSelect.value);

            // sizeSelect.dispatchEvent(new Event("change")); // Trigger change event
            // console.log('sizeSelect : ', sizeSelect);

            let changeEvent = new Event("change");
            sizeSelect.dispatchEvent(changeEvent); // Trigger change event
            console.log('sizeSelect : ', sizeSelect);

            let selectedText = this.getAttribute('data-text') || '';
            console.log("selectedText : ", selectedText);
            let selectedValue = this.textContent;
            console.log("selectedValue : ", selectedValue);
            let selectedHtml = '';

            if (selectedText) {
              selectedHtml += `<span class="dropdown-selected-option-text">${selectedText}</span>`;
            }

            // Update selected option text (without jQuery)
            let dropdownSelect = this.closest('.dropdown-select');
            let selectedOptionElement = dropdownSelect.querySelector('.dropdown-selected-option');
            if (selectedOptionElement) {
              selectedOptionElement.innerHTML = selectedHtml;
            }

            // Update hidden input value (without jQuery)
            let hiddenInput = dropdownSelect.querySelector('input[type="hidden"]');
            if (hiddenInput) {
              hiddenInput.value = selectedValue;
            }

            // Hide the dropdown options (without jQuery)
            let optionsContainer = this.parentElement;
            if (optionsContainer) {
              optionsContainer.style.display = 'none';
            }

            if(document.querySelector('.js-selected-option').classList.contains('is-select-dropdown-open')){
              document.querySelector('.js-selected-option').classList.remove('is-select-dropdown-open');
            }
            
          });
        }
      }

      document.addEventListener('click', function(e) {
        let dropdownSelect = document.querySelector('.dropdown-select');
        let dropdownOptions = document.querySelectorAll('.dropdown-options');
      
        if (!dropdownSelect.contains(e.target)) {
          dropdownOptions.forEach(function(option) {
            option.style.display = 'none';
          });
        }
      });

      document.querySelectorAll('.js-selected-option').forEach(function(element) {
        element.addEventListener('click', function() {
          document.querySelectorAll('.dropdown-options').forEach(function(option) {
            if (option !== element.nextElementSibling) {
              option.style.display = 'none';
            }
          });
      
          let dropdownOptions = element.nextElementSibling;
          if (dropdownOptions.style.display === 'none' || dropdownOptions.style.display === '') {
            dropdownOptions.style.display = 'block';
            element.classList.add('is-select-dropdown-open');
          } else {
            dropdownOptions.style.display = 'none';
            element.classList.remove('is-select-dropdown-open'); 
          }
        });
      });  

      let triggerFirstSelect = document.querySelector('.cw-product-bundle__variant-option');
      if (triggerFirstSelect) {
        let event = new Event('click', {
            'bubbles': true, 
            'cancelable': true 
        });
    
        // Dispatch the event
        // triggerFirstSelect.dispatchEvent(event);
      }

    }
  }
});





document.addEventListener('DOMContentLoaded', function() {
  // Get the select element
  var selectEl = document.querySelector('.metal-custom--color');
  
  if (selectEl) {
    // Get the selected value
    var selectedValue = selectEl.value;

    // Find the matching radio button
    var radios = document.querySelectorAll('.custom-radio--color');
    radios.forEach(function(radio) {
      if (radio.value === selectedValue) {
        radio.checked = true;
        // Trigger a change event
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // load
  var sizeSelect = document.getElementById("var-size");
  if (!sizeSelect) return; // Ensure the dropdown exists
  let label = document.querySelector('[for="var-size"]'); 
  if (label.parentNode.classList.contains('spb-label-tooltip')) {
    let parentNode = label.parentNode;
    let selectSizeWrapper = parentNode.querySelector('.select-size-button-wrapper');
    
    if (!selectSizeWrapper) {
      selectSizeWrapper = document.createElement("div");
      selectSizeWrapper.classList.add('select-size-button-wrapper');
      
      insertAfter(selectSizeWrapper, parentNode);
    }
    let existingSelecter = selectSizeWrapper.querySelector('.dropdown-select');
    if (selectSizeWrapper && !existingSelecter) {
      

      let existingSelecterWrap = selectSizeWrapper.querySelector('.cw-product-bundle__variant-select');
      if (!existingSelecterWrap) {
        let selecterWrap = document.createElement('div');
        selecterWrap.classList.add('cw-product-bundle__variant-select', 'dropdown-select', 'js-dropdown-select');
        
        let existingSelectedOption = selecterWrap.querySelector('.cw-product-bundle__variant-selected');
        
        if (!existingSelectedOption) {
          let selectedOption = document.createElement('div');
          selectedOption.classList.add('cw-product-bundle__variant-selected', 'dropdown-selected-option', 'js-selected-option');
    
          let selectedText = document.createElement('span');
          selectedText.classList.add('cw-product-bundle__variant-text', 'dropdown-selected-option-text');
          selectedText.textContent = 'Select Ring Size';
          
         selectedOption.appendChild(selectedText);
          selecterWrap.appendChild(selectedOption);
        }
    
        let existingOptionsWrapper = selecterWrap.querySelector('.cw-product-bundle__variant-options');
        if (!existingOptionsWrapper) {
          let optionsWrapper = document.createElement('div');
          optionsWrapper.classList.add('cw-product-bundle__variant-options', 'dropdown-options');
          selecterWrap.appendChild(optionsWrapper);
        }
    
        let existingHiddenInput = selecterWrap.querySelector('input[type="hidden"]');
        
        if (!existingHiddenInput) {
          let hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'selectedValue';
          hiddenInput.value = '';
          selecterWrap.appendChild(hiddenInput);
         
        }
    
        selectSizeWrapper.appendChild(selecterWrap);
        selectSizeWrapper.appendChild(selecterWrap);
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('size-error-message');
        errorMessage.textContent = 'Please select a ring size'; // Customize your message
        errorMessage.style.display = 'none'; // Initially hidden
        selectSizeWrapper.appendChild(errorMessage);

      } else {
        
      }
    }

    if(selectSizeWrapper.querySelector('.cw-product-bundle__variant-options')){
      console.log("existingOptionsWrapper For Option : ", selectSizeWrapper.querySelector('.cw-product-bundle__variant-options'));

      // Create the "Select Ring Size" placeholder option and append it first
      let placeholderOption = document.createElement("div");
      placeholderOption.classList.add('cw-product-bundle__variant-option', 'dropdown-option');
      placeholderOption.setAttribute('data-text', "");

      let placeholderText = document.createElement("span");
      placeholderText.classList.add('cw-product-bundle__option-text');
      placeholderText.textContent = "Select Ring Size"; // Placeholder text

      placeholderOption.appendChild(placeholderText);
      selectSizeWrapper.querySelector('.cw-product-bundle__variant-options').appendChild(placeholderOption);

      // Initially, set the "Select Ring Size" as selected (to display it as the default text)
      placeholderOption.classList.add("selected");
      
      // Loop through each option in the select dropdown
      for (let i = 0; i < sizeSelect.options.length; i++) {
        let option = sizeSelect.options[i];
        console.log("option : ", option);

        let value = option.value.trim();
        console.log("value : ", value);

        let text = option.text.trim();
        console.log("text : ", text);

        if (value) { // Avoid empty options
          let swatchBlock = document.createElement("div");
          swatchBlock.classList.add('cw-product-bundle__variant-option', 'dropdown-option');
          swatchBlock.setAttribute('data-text', value);

          let swatchOptionText = document.createElement("span");
          swatchOptionText.classList.add('cw-product-bundle__option-text');
          swatchOptionText.textContent = text;

          // let swatchMadeToOrder = document.createElement("span");
          // swatchMadeToOrder.textContent = "Made to Order";

          swatchBlock.appendChild(swatchOptionText);
          // swatchBlock.appendChild(swatchMadeToOrder);
          selectSizeWrapper.querySelector('.cw-product-bundle__variant-options').appendChild(swatchBlock);

          // if (sizeSelect.value === value) {
          //   swatchBlock.classList.add("selected");
          // }

          // Click event to update dropdown
          swatchBlock.addEventListener("click", function () {
            document.querySelectorAll(".dropdown-option").forEach(function(el) {
              el.classList.remove("selected");
            });
            this.classList.add("selected");

            sizeSelect.value = this.getAttribute("data-text");
            console.log("sizeSelect.value : ", sizeSelect.value);

            // sizeSelect.dispatchEvent(new Event("change")); // Trigger change event
            // console.log('sizeSelect : ', sizeSelect);

            let changeEvent = new Event("change");
            sizeSelect.dispatchEvent(changeEvent); // Trigger change event
            console.log('sizeSelect : ', sizeSelect);

            let selectedText = this.getAttribute('data-text') || '';
            console.log("selectedText : ", selectedText);
            let selectedValue = this.textContent;
            console.log("selectedValue : ", selectedValue);
            let selectedHtml = '';

            if (selectedText) {
              selectedHtml += `<span class="dropdown-selected-option-text">${selectedText}</span>`;
            }

            // Update selected option text (without jQuery)
            let dropdownSelect = this.closest('.dropdown-select');
            let selectedOptionElement = dropdownSelect.querySelector('.dropdown-selected-option');
            if (selectedOptionElement) {
              selectedOptionElement.innerHTML = selectedHtml;
            }

            // Update hidden input value (without jQuery)
            let hiddenInput = dropdownSelect.querySelector('input[type="hidden"]');
            if (hiddenInput) {
              hiddenInput.value = selectedValue;
            }

            // Hide the dropdown options (without jQuery)
            let optionsContainer = this.parentElement;
            if (optionsContainer) {
              optionsContainer.style.display = 'none';
            }

            if(document.querySelector('.js-selected-option').classList.contains('is-select-dropdown-open')){
              document.querySelector('.js-selected-option').classList.remove('is-select-dropdown-open');
            }
            
          });
        }
      }

      document.addEventListener('click', function(e) {
        let dropdownSelect = document.querySelector('.dropdown-select');
        let dropdownOptions = document.querySelectorAll('.dropdown-options');
      
        if (!dropdownSelect.contains(e.target)) {
          dropdownOptions.forEach(function(option) {
            option.style.display = 'none';
          });
        }
      });

      document.querySelectorAll('.js-selected-option').forEach(function(element) {
        element.addEventListener('click', function() {
          document.querySelectorAll('.dropdown-options').forEach(function(option) {
            if (option !== element.nextElementSibling) {
              option.style.display = 'none';
            }
          });
      
          let dropdownOptions = element.nextElementSibling;
          if (dropdownOptions.style.display === 'none' || dropdownOptions.style.display === '') {
            dropdownOptions.style.display = 'block';
            element.classList.add('is-select-dropdown-open');
          } else {
            dropdownOptions.style.display = 'none';
            element.classList.remove('is-select-dropdown-open'); 
          }
        });
      });  

      let triggerFirstSelect = document.querySelector('.cw-product-bundle__variant-option');
      if (triggerFirstSelect) {
        let event = new Event('click', {
            'bubbles': true, 
            'cancelable': true 
        });
    
        // Dispatch the event
        // triggerFirstSelect.dispatchEvent(event);
      }

    }
  }

  // var swatchContainer = document.createElement("div");
  // swatchContainer.className = "swatch-container";

  

  // let sizeSelectionWrap = document.createElement("div");
  // sizeSelectionWrap.classList.add('size-swatch-wrapper');
  // sizeSelectionWrap.id = 'select-size-popup';
  // sizeSelectionWrap.style.display = "none";

  // // Insert swatches before the dropdown
  // sizeSelect.parentNode.insertBefore(sizeSelectionWrap, sizeSelect);
  // sizeSelectionWrap.appendChild(swatchContainer);
});

document.addEventListener('change', function(event) {
  if (event.target.name === "properties[Engraving]") {
    let engravingInput = document.querySelector('[name="properties[Engraving Text]"]');
    engravingInput.value = ''; // Clears the input field
    engravingInput.textContent = ''; // Clears any text content (if applicable)
    let engravingTextElement = document.querySelector('[name="properties[Engraving Text]"]');
    let productPriceElement = document.querySelector(".variant-selection__variants");
    let engravingProductPrice = document.body.getAttribute("data-engraving-product");
    let selectedOption = productPriceElement.options[productPriceElement.selectedIndex]; // Get selected <option>
    let productPrice = selectedOption.getAttribute("data-price-without-formate");
    let productOrignalPrice = selectedOption.getAttribute("data-price-with-formate");
    let totalPrice = (parseFloat(productPrice) || 0) + (parseFloat(engravingProductPrice) || 0);
    let moneyFormat = document.body.getAttribute("data-money-format");
    let formattedPrice = Shopify.formatMoney(totalPrice, moneyFormat);
    let orignalPrice = Shopify.formatMoney(productPrice, moneyFormat);
    let priceElementt = document.querySelector(".engraving-product-addition--price");
    if (event.target.value.toLowerCase() === "no") {
      priceElementt.textContent = orignalPrice;
    }
    if (event.target.value.toLowerCase() === "yes" && engravingInput && engravingInput.value.trim() !== '') {
      priceElementt.textContent = formattedPrice;
    }
    
  }
});

let productSection = document.querySelector('.product_section');


function elementInViewport() {
  window.addEventListener('scroll', function() {
    if (productSection) {
      let bounding = productSection.getBoundingClientRect();
      let sectionHeight = productSection.offsetHeight - 115;
      let sectionWidth = productSection.offsetWidth;

      if (bounding.top >= -sectionHeight &&
        bounding.left >= -sectionWidth &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + sectionWidth &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + sectionHeight) {

        document.querySelector('.purchase-details__buttons button.action_button').classList.remove('is-active-sticky-atc');
      } else {
        document.querySelector('.purchase-details__buttons button.action_button').classList.add('is-active-sticky-atc');
      }
    }
  });
}

function waitToElement(selector, trigger, delayInterval, delayTimeout) {
  if(document.querySelector('#infiniteoptions-container .spb-label-tooltip label[for="Size-0-0"]')){
  }

  let interval = setInterval(function () {
    if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
      clearInterval(interval);
      trigger();
    }
  }, delayInterval);
  setTimeout(function () {
    clearInterval(interval);
  }, delayTimeout);
}
  
function onLoadFlickityLibrary(trigger, delayInterval, delayTimeout) {
  let interval = setInterval(function () {
    if (typeof Flickity !== 'undefined') {
      clearInterval(interval);
      trigger();
    }
  }, delayInterval);
  setTimeout(function () {
    clearInterval(interval);
  }, delayTimeout);
}

function productGalleryflickty() {
  let flickityInstance = Flickity.data(document.querySelector('.product-gallery__main'));
  flickityInstance.options.cellAlign = 'left';
  flickityInstance.resize();
  // flickityInstance.reloadCells();
}

/*
document.addEventListener('DOMContentLoaded', function() {
  let customerLogoSliders = document.querySelectorAll('.js-customer-logo-slider');

  if (customerLogoSliders.length) {
    customerLogoSliders.forEach(function(slider) {
      const logoSwiper = new Swiper(slider, {
        loop: true,
        slidesPerView: 'auto',
        freeMode: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: slider.closest('.customer-logo__wrapper').querySelector('.swiper-button-next'),
          prevEl: slider.closest('.customer-logo__wrapper').querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
        },
        spaceBetween: 15,
        speed: 2500,
        direction: 'horizontal',
        breakpoints: {
          767: {
            loop: false,
            autoplay: false,
            spaceBetween: 40,
            speed: 1000,
            freeMode: false,
          },  
        },
      });
    });
  }
});
*/

window.onload = function() {
  if(productSection && window.innerWidth < 768){
    elementInViewport();
  }

  if (window.innerWidth <= 750) {
    onLoadFlickityLibrary(function () {
      waitToElement('.product-gallery__main', productGalleryflickty , 600, 8000);
    }, 250, 6000);
  }
};

let colorSwatchLabel = document.querySelector('.selector-wrapper .spb-label-tooltip label[for="data-variant-option-0"]');
let colorSwatchInput = document.querySelectorAll('.custom-radio--color');

function insertAfter(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

function insertBefore(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode);
}

function updateSelectedColorValue(inputValue) {
  let selectedColor = document.querySelector(".selected-color-swatch-val");

  if(colorSwatchLabel.parentNode.classList.contains('spb-label-tooltip') && !(colorSwatchLabel.parentNode.classList.contains('spb-label-select-val'))){
    colorSwatchLabel.parentNode.classList.add('spb-label-select-val');
  }

  if (!selectedColor) {
    selectedColor = document.createElement('span');
    selectedColor.classList.add('selected-color-swatch-val');
    colorSwatchLabel.parentNode.insertBefore(selectedColor, colorSwatchLabel.nextSibling);
  } 

  selectedColor.textContent = inputValue;

  let checkColoneTag = colorSwatchLabel.parentNode.querySelector('i');
  if (!checkColoneTag) {
    let iTag = document.createElement('i'); 
    iTag.textContent = ':'; 
    insertBefore(iTag, selectedColor);
  }
}

function colorSwatchSelectedVal() {
  let selectedInput = document.querySelector('.cus-variant-ui .custom-radio--color:checked');
  if (selectedInput && (selectedInput.value !== "" && selectedInput.value !== null)) {
    updateSelectedColorValue(selectedInput.getAttribute('data-color-value').trim());
  }
}

waitToElement('.cus-variant-ui .custom-radio--color:checked' , colorSwatchSelectedVal , 100, 10000);

colorSwatchInput.forEach(function(input) {
  input.addEventListener("change", function (inputEvent) {
    
    let inputVal = inputEvent.target.value;
    if(inputVal !== "" && inputVal !== null) {
      updateSelectedColorValue(input.getAttribute('data-color-value').trim());
    }
  });
});

document.addEventListener('click', function(event) {
  const target = event.target.closest('.cw-product-bundle__variant-option');
  if (target) {
    const selectedText = target.getAttribute('data-text');
    const errorMessage = document.querySelector('.size-error-message');
    if (selectedText !== 'Select Ring Size') {
      if (errorMessage) errorMessage.style.display = 'none';
    } else {
      if (errorMessage) errorMessage.style.display = 'block';
    }
  }
});

